import React from 'react';
import { useGTM } from '@rakutenfrance/gtm-provider';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { StyledDiv, Container, titleExtension, descExtension, imgContainer, btnContainer } from './ExtensionClub.style';
import { Button } from '../Button';
export const ExtensionClub = () => {
    const getBrowserLabel = () => {
        if (typeof window === 'undefined') {
            return {
                type: 'unknown',
                label: '',
                link: '',
                img: 'default-image-url',
            };
        }
        const userAgent = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || '';
        if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
            return {
                type: 'safari',
                label: ' Safari',
                link: 'https://apps.apple.com/fr/app/rakuten-cashback-europe/id1661070420?mt=12',
                img: 'https://fr.shopping.rakuten.com/visuels/0_next-common/club-r-pay/Extension_Safari_200x200.png',
            };
        }
        if (userAgent.includes('Firefox')) {
            return {
                type: 'firefox',
                label: ' Firefox',
                link: 'https://addons.mozilla.org/fr/firefox/addon/club-rakuten-everywhere/',
                img: 'https://fr.shopping.rakuten.com/visuels/0_next-common/club-r-pay/Extension_Firefox_200x200.png',
            };
        }
        if (userAgent.includes('Chrome')) {
            return {
                type: 'chrome',
                label: ' Chrome',
                link: 'https://chromewebstore.google.com/detail/extension-club-r/hnchgcelpejnpglbnaieofanfoikiepb?hl=fr&pli=1',
                img: 'https://fr.shopping.rakuten.com/visuels/0_next-common/club-r-pay/Extension_Chrome_200x200.png',
            };
        }
        return {
            type: 'unknown',
            label: '',
            link: 'https://fr.shopping.rakuten.com/event/extension-club-r-everywhere',
            img: 'https://fr.shopping.rakuten.com/visuels/0_next-common/club-r-pay/Extension_Chrome_200x200.png',
        };
    };
    const { type, label, link, img } = getBrowserLabel();
    const { sendEvent } = useGTM();
    const openExtensionPage = () => {
        if (link) {
            sendEvent({
                location_alias: "affiliate",
                page_title: "affiliate",
                event: 'download_extension',
                page: 'affiliate',
                type: 'code_promo',
                browser: type,
            });
            window.open(link, '_blank');
        }
    };
    return (React.createElement(StyledDiv, null,
        React.createElement(Container, null,
            React.createElement("div", { style: imgContainer },
                React.createElement("img", { "data-qa": "imgBrowser", src: img, height: 100 })),
            React.createElement("p", { style: titleExtension },
                "Du cashback encore plus simplement avec l\u2019extension",
                label.toString(),
                " !"),
            React.createElement("p", { style: descExtension }, "Cumulez du cashback \u00E0 chacun de vos achats sur les sites partenaires et d\u00E9pensez-les sur le site Rakuten."),
            React.createElement("div", { style: btnContainer },
                React.createElement(Button, { color: "primary", variant: "contained", startIcon: React.createElement(SaveAltIcon, null), onClick: () => openExtensionPage(), sx: { width: '100%', margin: '16px' } },
                    "T\u00E9l\u00E9charger l\u2019extension",
                    label.toString())))));
};
